import type {
  GetGroupedReleaseNotesResponseDTO,
  LatestReleaseNoteDto,
} from 'declarations/dto/releaseNotes';

import { get } from './api';

export const getGroupedReleaseNotesApi = async (): Promise<GetGroupedReleaseNotesResponseDTO> => {
  const response = await get<GetGroupedReleaseNotesResponseDTO>('/release-notes/grouped');

  return response.data;
};

export const getLatestReleaseNoteApi = async (): Promise<LatestReleaseNoteDto> => {
  const response = await get<LatestReleaseNoteDto>('/release-notes/latest');

  return response.data;
};
